import React from 'react'
import cx from 'classnames'
import { useTable } from 'react-table'

import { TableType } from '@components/Table/interface'
import { Loading } from '@components/Loading'
import NoData from '@components/NoData'

const defaultPropGetter = () => ({})
export function Table({
  columns,
  data,
  className,
  loading,
  fixedHeader = false,
  getHeaderProps = defaultPropGetter,
  getColumnProps = defaultPropGetter,
  getRowProps = defaultPropGetter,
  getCellProps = defaultPropGetter,
}: TableType) {
  const { rows, prepareRow, headerGroups, getTableProps, getTableBodyProps } =
    useTable({
      columns,
      data,
    })
  const isEmpty = rows.length === 0

  return (
    <div
      className={cx(className, {
        'overflow-y-auto': fixedHeader,
      })}
    >
      <table {...getTableProps()} className={cx(className, 'w-full')}>
        <thead
          className={cx({
            'sticky top-[-1px] bg-white dark:bg-dark-8 border-b border-gray dark:border-purple':
              fixedHeader,
          })}
        >
          {headerGroups.map((headerGroup: any, index: number) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column: any) => (
                <th
                  {...column.getHeaderProps([
                    {
                      className: column.className,
                      style: { minWidth: column.minWidth, width: column.width },
                    },
                    getColumnProps(column),
                    getHeaderProps(column),
                  ])}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {loading ? (
            <tr>
              <td
                colSpan={headerGroups[headerGroups.length - 1]?.headers.length}
              >
                <div className='w-full flex justify-center py-5'>
                  <Loading size={50} />
                </div>
              </td>
            </tr>
          ) : isEmpty ? (
            <tr>
              <td
                colSpan={headerGroups[headerGroups.length - 1]?.headers.length}
              >
                <NoData />
              </td>
            </tr>
          ) : (
            rows.map((row: any, index: number) => {
              prepareRow(row)
              return (
                <tr {...row.getRowProps(getRowProps(row))}>
                  {row.cells.map((cell: any) => (
                    <td
                      {...cell.getCellProps([
                        {
                          className: cell.column.className,
                          style: {
                            minWidth: cell.column.minWidth,
                            width: cell.column.width,
                          },
                        },
                        getColumnProps(cell.column),
                        getCellProps(cell),
                      ])}
                    >
                      {cell.render('Cell', {
                        records: rows.map((record: any) => record.original),
                        record: row.original,
                      })}
                    </td>
                  ))}
                </tr>
              )
            })
          )}
        </tbody>
      </table>
    </div>
  )
}
